import api from "../../../api/api";

/**
 * Audit Log Management (Root Admin)
 * 对应文档: 6.1 搜索 Audit Logs
 */

/**
 * 搜索审计日志
 * @param {Object} params - 查询参数
 * @param {number} [params.page=1] - 页码
 * @param {number} [params.limit=20] - 每页数量
 * @param {string} [params.category] - 分类 (AUTH, SECURITY, COMPANY, TAX_COMPUTATION, INTEGRATION, SUBSCRIPTION, SYSTEM)
 * @param {string} [params.action] - 动作名称 (模糊搜索)
 * @param {string} [params.status] - 状态 (SUCCESS, FAILURE, WARNING)
 * @param {string} [params.actor_email] - 操作者邮箱 (模糊搜索)
 * @param {string} [params.actor_id] - 操作者 ID (精确匹配)
 * @param {string} [params.target_id] - 目标对象 ID
 * @param {string} [params.target_type] - 目标对象类型 (user, company, tax_computation, subscription, payment, external_api, security_event, system_job)
 * @param {string} [params.request_id] - 请求追踪 ID
 * @param {string} [params.ip_address] - IP 地址
 * @param {string} [params.from] - 开始时间 (ISO string, e.g. '2026-01-01')
 * @param {string} [params.to] - 结束时间 (ISO string, e.g. '2026-12-31')
 * @returns {Promise}
 */
export const searchAuditLogs = (params) =>
  api.get("/root/audit-logs", { params });
